import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './Image/miles-morales-logo.png';
import { FaBars, FaTimes, FaSun, FaMoon } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

function MobileNav() {
  const [darkMode, setDarkMode] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    const isDark = document.documentElement.classList.contains('dark') || document.body.classList.contains('dark');
    setDarkMode(isDark);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDarkMode = () => {
    const nextDark = !darkMode;
    setDarkMode(nextDark);
    document.documentElement.classList.toggle('dark', nextDark);
    document.body.classList.toggle('dark', nextDark);
  };

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 20);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="md:hidden fixed top-0 left-0 w-full z-50 px-4 pt-4 pb-2 transition-all duration-300 pointer-events-none">
      <nav className={`w-full glass rounded-full px-5 py-3 flex justify-between items-center transition-all duration-300 pointer-events-auto ${
        isScrolled ? 'shadow-md translate-y-1' : 'shadow-sm'
      }`}>
        {/* Logo */}
        <NavLink to="/" className="flex items-center gap-2" onClick={() => setMenuOpen(false)}>
          <div className="w-7 h-7 rounded-full overflow-hidden border border-teal-500/20">
            <img src={Logo} alt="avatar" className="w-full h-full object-cover" />
          </div>
          <span className="font-semibold tracking-wide text-sm code-font gradient-text">
            {"< Amiola_Dev />"}
          </span>
        </NavLink>

        {/* Menu Buttons */}
        <div className="flex items-center gap-4">
          <button 
            onClick={toggleDarkMode} 
            className="w-8 h-8 flex items-center justify-center rounded-full border border-slate-200 dark:border-slate-800 bg-white/50 dark:bg-slate-900/50 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-slate-600 dark:text-slate-300"
            aria-label="Toggle theme"
          >
            {darkMode ? <FaMoon className="w-3.5 h-3.5" /> : <FaSun className="w-3.5 h-3.5" />}
          </button>
          
          <button 
            onClick={toggleMenu} 
            className="w-8 h-8 flex items-center justify-center rounded-full border border-slate-200 dark:border-slate-800 bg-white/50 dark:bg-slate-900/50 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            aria-label="Toggle menu"
          >
            {menuOpen ? <FaTimes className="text-slate-600 dark:text-slate-300" size={14} /> : <FaBars className="text-slate-600 dark:text-slate-300" size={14} />}
          </button>
        </div>
      </nav>

      {/* Slide down menu drawer */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute top-16 left-4 right-4 z-40 glass rounded-2xl p-6 shadow-xl pointer-events-auto"
          >
            <div className="flex flex-col items-center gap-4 text-base font-medium tracking-wide">
              <NavLink 
                to="/" 
                className={({ isActive }) => `w-full text-center py-2 rounded-xl transition-colors hover:bg-slate-100 dark:hover:bg-slate-800/50 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold bg-teal-50/30 dark:bg-teal-950/20" : "text-slate-600 dark:text-slate-300"}`} 
                onClick={toggleMenu}
              >
                Home
              </NavLink>
              <NavLink 
                to="/about" 
                className={({ isActive }) => `w-full text-center py-2 rounded-xl transition-colors hover:bg-slate-100 dark:hover:bg-slate-800/50 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold bg-teal-50/30 dark:bg-teal-950/20" : "text-slate-600 dark:text-slate-300"}`} 
                onClick={toggleMenu}
              >
                About
              </NavLink>
              <NavLink 
                to="/portfolio" 
                className={({ isActive }) => `w-full text-center py-2 rounded-xl transition-colors hover:bg-slate-100 dark:hover:bg-slate-800/50 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold bg-teal-50/30 dark:bg-teal-950/20" : "text-slate-600 dark:text-slate-300"}`} 
                onClick={toggleMenu}
              >
                Portfolio
              </NavLink>
              <NavLink 
                to="/contact" 
                className={({ isActive }) => `w-full text-center py-2 rounded-xl transition-colors hover:bg-slate-100 dark:hover:bg-slate-800/50 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold bg-teal-50/30 dark:bg-teal-950/20" : "text-slate-600 dark:text-slate-300"}`} 
                onClick={toggleMenu}
              >
                Contact
              </NavLink>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default MobileNav;